"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/display-name */
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var DataTable_1 = __importDefault(require("../DataTable/DataTable"));
var JSONTable = function (props) {
    // get shape of data
    var convertTitle = function (string) {
        return ("" + string[0].toUpperCase() + string.substring(1))
            .replace(/([ABCDEFGHIJKLMNOPQRSTUVWXYZ])/g, function (v) { return " " + v; })
            .replace(/(_?)/g, function (v) { return v.toUpperCase().replace("_", " "); });
    };
    var availableColumns = [];
    props.data.forEach(function (row) {
        return Object.keys(row).forEach(function (prop) {
            if (!availableColumns.find(function (entry) { return entry.field === prop; })) {
                if ((props.hidden || []).indexOf(prop) < 0) {
                    availableColumns.push((props.overrides || {})[prop] || {
                        field: prop,
                        title: convertTitle(prop),
                        render: function (record) { return (react_1.default.createElement(core_1.Tooltip, { arrow: true, title: react_1.default.createElement(core_1.Typography, { variant: "caption" }, record[prop]) },
                            react_1.default.createElement(core_1.Typography, null, record[prop]))); }
                    });
                }
            }
        });
    });
    return (react_1.default.createElement(DataTable_1.default, { data: props.data, columns: availableColumns.sort(function (a, b) { return (a.field < b.field ? -1 : 1); }) }));
};
JSONTable.propTypes = {
    data: prop_types_1.default.array,
    overrides: prop_types_1.default.object,
    hidden: prop_types_1.default.array
};
exports.default = JSONTable;
